<template>
  <div class="chart-wrap">
    <div class="axis-tip"></div>
    <div class="chart" ref="line"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      widthPix: 1,
    };
  },
  props: {
    showLegend: {
      default: true,
    },
    yName: {
      default: "单位：人",
    },
  },
  methods: {
    initChart(series, category) {
      let myChart = null;
      if (myChart != null && myChart != "" && myChart != undefined) {
        myChart.dispose();
      }
      var chartDom = this.$refs.line;
      myChart = echarts.init(chartDom);
      var option;
      option = {
        legend: {
          show: this.showLegend,
          right: 0 * this.widthPix,
          top: 0 * this.widthPix,
          itemWidth: 12 * this.widthPix,
          itemHeight: 2 * this.widthPix,
          itemGap: 30 * this.widthPix,
          textStyle: {
            color: "#BDCDE4",
            fontSize: 12 * this.widthPix,
          },
        },
        xAxis: {
          type: "category",
          data: category,

          axisTick: {
            show: false,
          },
          triggerEvent: true,
          axisLabel: {
            color: "#FFFFFF",
            fontSize: 12 * this.widthPix,
            // rotate: -50,
            interval: 0,
            lineHeight: 20 * this.widthPix,
            formatter: (value) => {
              const firstWord = value.slice(0, 6);
              let endWord = value.slice(6, value.length);
              if (endWord.length > 6) {
                endWord = endWord.slice(0, 5) + "...";
              }
              return firstWord + "\n" + endWord;
            },
          },
          aixsLine: {
            show: false,
            lineStyle: {
              color: "#3C5787",
            },
          },
        },

        yAxis: {
          type: "value",
          name: this.yName,
          nameGap: 19,
          nameTextStyle: {
            color: "#AEC3DC",
            fontSize: 12,
          },
          // max:100,
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "rgba(178, 194, 211, 0.2)",
            },
          },
          aixsLine: {
            show: true,
            lineStyle: {
              color: "#3C5787",
            },
          },
          axisLabel: {
            color: "#6887A5",
            fontSize: 14 * this.widthPix,
          },
        },
        grid: {
          left: 40 * this.widthPix,
          right: 0 * this.widthPix,
          top: 40 * this.widthPix,
          bottom: 50 * this.widthPix,
        },
        barWidth: 6 * this.widthPix,
        series: series,
      };
      myChart.clear();
      option && myChart.setOption(option);
      myChart.on("mouseover", "xAxis", function (e) {
        let axisTip = document.querySelector(".axis-tip");
        axisTip.innerText = e.value;
        axisTip.style.left = e.event.offsetX + "px";
        axisTip.style.top = e.event.offsetY - 20 + "px";
        axisTip.style.display = "block";
      });
      myChart.on("mouseout", "xAxis", function (e) {
        let axisTip = document.querySelector(".axis-tip");
        axisTip.innerText = "";
        axisTip.style.display = "none";
      });
    },
  },
  mounted() {
    this.widthPix =
      window.screen.width < 1920 ? 1 : Math.floor(window.screen.width / 1920);
    // this.initChart();
  },
};
</script>
<style lang="scss" scoped>
.chart-wrap {
  width: 100%;
  height: 100%;
}
.chart {
  width: 100%;
  height: 100%;
}
.axis-tip {
  display: none;
  position: absolute;
  white-space: nowrap;
  padding: 0.0417rem;
  font-size: 0.0625rem;
  line-height: 0.1042rem;
  color: #fff;
  background: #303133;
  border-radius: 0.0417rem;
  bottom: 0;
  left: 0;
  z-index: 9;
  height: fit-content;
}
</style>
